import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PointerDiv from "./PointerDiv";
import { PendingLicencePurchaseSummary } from "../../../../types/PendingLicencePurchase/PendingLicencePurchaseSummary";
import usePendingLicencePurchaseService from "../../../../hooks/usePendingLicencePurchaseService";
import { useNavigate } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useCurrencyContext } from "../../../../context/Currency/CurrencyContext";

const UpgradeLicence = () => {
  const pendingLicencePurchaseService = usePendingLicencePurchaseService();

  const { selectedCurrency: currency } = useCurrencyContext();

  const navigate = useNavigate();

  const navigateToPurchaseLicence = () => {
    pendingLicencePurchaseService
      .create(currency!.code)
      .then((summary: PendingLicencePurchaseSummary) => {
        navigate("/purchase-licence", {
          state: { id: summary.id, hash: summary.hash },
        });
      });
  };

  return (
    <PointerDiv
      showPointer={false}
      onClick={navigateToPurchaseLicence}
      className="pe-auto d-flex flex-row align-items-center gap-1 mb-1"
    >
      <FontAwesomeIcon icon={faPlus} color="white" size="lg" />
      <span className="mt-1 mr-2 text-white">Upgrade plan</span>
    </PointerDiv>
  );
};

export default UpgradeLicence;
